<template>
  <div class="ModuleTwo">
    <!-- <div class="ModuleTwo_title">打卡点评</div> -->
    <div class="title_box">
      <img class="title_icon" src="@/assets/home/title/title_2.png" alt="" />
    </div>

    <div class="ModuleTwo_list">
      <div
        class="list_item"
        v-if="activity.dianping_switch"
        @click="dianPing()"
      >
        <img class="icon" src="@/assets/home/dzdp.png" />
        <div class="title">去点评+打卡</div>
      </div>
      <div class="list_item" v-if="activity.poi_switch" @click="poi()">
        <img class="icon" src="@/assets/home/dy.png" />
        <div class="title">去点评+收藏</div>
      </div>
      <div class="list_item" v-if="activity.gaode_switch" @click="gaoDe()">
        <div>
          <img class="icon" src="@/assets/home/gaode.png" />
          <div class="title">点评+收藏</div>
        </div>
      </div>
      <div
        class="list_item"
        v-if="activity.xiecheng_switch"
        @click="XieCheng()"
      >
        <div>
          <img class="icon" src="@/assets/home/Ctrip.png" />
          <div class="title">携程点评</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ClipboardJS from 'clipboard';
import { Toast, Dialog } from 'vant-green';
export default {
  name: 'ModuleTwo',
  data() {
    return {
      //
    };
  },

  computed: {
    ...mapState({
      activity: (state) => state.activity.form,
      PageType: (state) => state.activity.PageType,
    }),
  },

  created() {},

  methods: {
    ...mapActions('activity', ['getTouchData']),
    // 剪切板
    cope(value) {
      var clipboard = new ClipboardJS('body', {
        text: function () {
          return value;
        },
      });
      clipboard.on('success', function (e) {
        clipboard.destroy();
        e.clearSelection();
        return e.text;
      });

      clipboard.on('error', function () {
        console.log('复制失败');
      });
      return value;
    },

    // 去点评+打卡
    dianPing() {
      if (this.PageType === 2 || this.PageType === '2') {
        this.$emit('openCover');
        return;
      }
      this.$store
        .dispatch('activity/getActivityDetail', { id: this.activity.id })
        .then((res) => {
          // 新版本
          var imgList = [];
          for (var i = 0; i < this.activity.dianping_image.length; i++) {
            imgList.push(this.activity.dianping_image[i].path);
          }
          var params = {
            title: '点评文案', // 弹窗标题
            content: this.activity.dianping_content, // 文案内容
            imgList: imgList, // 图片列表
            // imgList: [
            //   'https://img0.baidu.com/it/u=2191392668,814349101&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1399',
            //   'https://img0.baidu.com/it/u=2191392668,814349101&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1399'
            // ],// 图片列表
            url: this.activity.dianping_scheme, // 跳转链接
            type: 7, // 类型
            btnText: '大众点评', // 按钮文案
          };
          this.$emit('openPopup', params);
        });

      // // 旧版本
      // this.cope(this.activity.dianping_content);
      // if (this.cope(this.activity.dianping_content)) {
      //   // MessageBox.confirm("允许复制文案到剪切板").then(() => {
      //   //   window.location.href = this.activity.dianping_scheme;
      //   // });
      //   Dialog.confirm({
      //     // title: '标题',
      //     message: '允许复制文案到剪切板',
      //     // confirmButtonText: '确认',
      //     // cancelButtonText: '取消'
      //   })
      //     .then(() => {
      //       // on confirm
      //       window.location.href = this.activity.dianping_scheme;
      //     })
      //     .catch(() => {
      //       // on cancel
      //     });
      // }
    },

    // 去点评+收藏
    poi() {
      if (this.PageType === 2 || this.PageType === '2') {
        this.$emit('openCover');
        return;
      }
      this.$store
        .dispatch('activity/getActivityDetail', { id: this.activity.id })
        .then((res) => {
          // 新版本
          var imgList = [];
          if(this.activity.poi_image&& this.activity.poi_image.length){
            for (var i = 0; i < this.activity.poi_image.length; i++) {
              imgList.push(this.activity.poi_image[i].path);
            }
          }

          var params = {
            title: '点评文案', // 弹窗标题
            content: this.activity.poi_content, // 文案内容
            imgList: imgList, // 图片列表
            // imgList: [
            //   'https://img0.baidu.com/it/u=2191392668,814349101&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1399',
            //   'https://img0.baidu.com/it/u=2191392668,814349101&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1399'
            // ],// 图片列表
            type: 12, // 类型
            url: this.activity.poi_scheme, // 跳转链接
            btnText: '抖音点评', // 按钮文案
          };
          this.$emit('openPopup', params);
        });
      // this.cope(this.activity.poi_content);
      // if (this.cope(this.activity.poi_content)) {
      //   this.getTouchData({id: this.activity.id, type: 12 })
      //   Dialog.confirm({
      //     // title: '标题',
      //     message: '允许复制文案到剪切板',
      //     // confirmButtonText: '确认',
      //     // cancelButtonText: '取消'
      //   })
      //     .then(() => {
      //       // on confirm
      //       window.location.href = this.activity.poi_scheme;
      //     })
      //     .catch(() => {
      //       // on cancel
      //     });
      // }
    },

    // 点评+收藏
    gaoDe() {
      if (this.PageType === 2 || this.PageType === '2') {
        this.$emit('openCover');
        return;
      }

      this.$store
        .dispatch('activity/getActivityDetail', { id: this.activity.id })
        .then((res) => {
          // 新版本
          var imgList = [];
          for (var i = 0; i < this.activity.gaode_image.length; i++) {
            imgList.push(this.activity.gaode_image[i].path);
          }
          var params = {
            title: '点评文案', // 弹窗标题
            content: this.activity.gaode_content, // 文案内容
            imgList: imgList, // 图片列表
            // imgList: [
            //   'https://img0.baidu.com/it/u=2191392668,814349101&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1399',
            //   'https://img0.baidu.com/it/u=2191392668,814349101&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1399'
            // ],// 图片列表
            type: 9, // 类型
            url: this.activity.gaode_scheme, // 跳转链接
            btnText: '高德点评', // 按钮文案
          };
          this.$emit('openPopup', params);
        });

      // this.cope(this.activity.gaode_content);
      // if (this.cope(this.activity.gaode_content)) {
      //   // MessageBox.confirm("允许复制文案到剪切板").then(() => {
      //   //   window.location.href = this.activity.gaode_scheme;
      //   // });
      //   Dialog.confirm({
      //     // title: '标题',
      //     message: '允许复制文案到剪切板',
      //     // confirmButtonText: '确认',
      //     // cancelButtonText: '取消'
      //   })
      //     .then(() => {
      //       // on confirm
      //       window.location.href = this.activity.gaode_scheme;
      //     })
      //     .catch(() => {
      //       // on cancel
      //     });
      // }
    },

    // 携程  点评+收藏
    XieCheng() {
      if (this.PageType === 2 || this.PageType === '2') {
        this.$emit('openCover');
        return;
      }

      this.$store
        .dispatch('activity/getActivityDetail', { id: this.activity.id })
        .then((res) => {
          // 新版本
          var imgList = [];
          for (var i = 0; i < this.activity.xiecheng_image.length; i++) {
            imgList.push(this.activity.xiecheng_image[i].path);
          }
          var params = {
            title: '点评文案', // 弹窗标题
            content: this.activity.xiecheng_content, // 文案内容
            imgList: imgList, // 图片列表
            // imgList: [
            //   'https://img0.baidu.com/it/u=2191392668,814349101&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1399',
            //   'https://img0.baidu.com/it/u=2191392668,814349101&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1399'
            // ],// 图片列表
            type: 10, // 类型
            url: this.activity.xiecheng_scheme, // 跳转链接
            btnText: '携程点评', // 按钮文案
          };
          this.$emit('openPopup', params);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.ModuleTwo {
  padding: 0 4%;
  // margin-top: 10px;
  .ModuleTwo_title {
    color: #ffffff;
    font-size: 13px;
    text-align: left;
    margin: 6px 0 2px 0;
    font-weight: bolder;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8),
      0 0 10px rgba(255, 255, 255, 0.3);
  }

  .title_box {
    text-align: left;
    .title_icon {
      // width: 109px;
      width: 95px;
      height: auto;
    }
  }

  .ModuleTwo_list {
    margin-top: 5px;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    .list_item {
      // width: 106px;
      width: 30%;
      height: 74px;
      // background-image: url("@/assets/home/btn_bg.png");
      background-image: url('../../assets/home/btn_bg.png');
      background-repeat: round;
      background-size: cover;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-right: 5%;
      margin-bottom: 12px;
      .icon {
        width: 35px;
        height: 35px;
        border-radius: 50%;
      }
      .title {
        font-size: 14px;
        color: #000000;
        font-weight: bold;
      }
    }
    // .list_item:last-child {
    //   margin-right: 0;
    // }
    .list_item:nth-child(3n) {
      margin-right: 0;
    }
  }
}
</style>
